import { UnitType } from '@exodus/currency'

const name = 'osmosis'
const displayName = 'Osmosis'
const ticker = 'OSMO'
const displayTicker = 'OSMO'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#6967EA'
const gradientColors = ['#6967EA', '#9E9CFC']
const gradientCoords = { x1: '37%', y1: '39%', x2: '-1.155%', y2: '4.909%' }
const chainBadgeColors = gradientColors

const units = {
  uosmo: 0,
  OSMO: 6,
}
const currency = UnitType.create(units)

const assetType = 'COSMOS_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://www.mintscan.io/osmosis/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://www.mintscan.io/osmosis/txs/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Osmosis is a decentralized exchange (DEX) that operates on the Cosmos ecosystem and provides bridged assets from Ethereum and Polkadot. It has greater control over the full blockchain stack, allowing for the development of Superfluid Staking and a transaction mempool that is shielded with threshold encryption. Osmosis aims to build a cross-chain native DEX and trading suite that connects all chains over IBC, and has invited external developers to create a DEX ecosystem with lending, credit, margin, fiat on-ramps, Defi strategy vaults, NFTs, stablecoins, and more.',
  reddit: 'https://www.reddit.com/r/OsmosisLab/',
  twitter: 'https://twitter.com/osmosiszone',
  website: 'https://osmosis.zone',
  telegram: 'https://t.me/osmosis_chat',
  discord: 'https://discord.com/invite/osmosis',
  medium: 'https://medium.com/osmosis',
}

export const asset = {
  assetType,
  baseAssetName,
  baseDenom: 'uosmo',
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
